import { Box, CircularProgress, Typography } from "@mui/material";
import { useEventHistory } from "../hooks/useEventHistory";

export const EventHistory = ({ projectId, activityId, dueDate }: { projectId: string | undefined; activityId: string | undefined; dueDate: string | undefined; }) => {

    const { eventData, loading, isError, error } = useEventHistory({ projectId, activityId, dueDate });

    if (loading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    if (isError) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <Typography variant="h6" color="error">
                    {error || "Error loading data."}
                </Typography>
            </Box>
        )
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="body2">
                Operation: {eventData?.recurring_plan_display_text}
            </Typography>
            <Typography variant="body2">
                Due Date: {eventData?.due_date}
            </Typography>
            <Typography variant="body2">
                Completed Date: {eventData?.completed_date || 'N/A'}
            </Typography>
            <Typography variant="body2">
                Status: {eventData?.status_display_text}
            </Typography>
            <Typography variant="body2">
                Details: {eventData?.helper_text}
            </Typography>
        </Box>
    );

};